import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import type { TooltipContentProps } from 'recharts'
import type { DailyUserStatItem } from '../api/admin-api'

interface DailyUserStatsChartProps {
  data: DailyUserStatItem[]
}

function formatDateLabel(dateStr: string): string {
  const date = new Date(dateStr)
  const dayNames = ['일', '월', '화', '수', '목', '금', '토']
  return `${date.getMonth() + 1}/${date.getDate()} (${dayNames[date.getDay()]})`
}

function formatNumber(num: number): string {
  return num.toLocaleString('ko-KR')
}

function CustomTooltip({ active, payload, label }: Partial<TooltipContentProps<number, string>>) {
  if (!active || !payload?.length) return null
  const rawValue = payload[0]?.value
  const userCount = typeof rawValue === 'number' ? rawValue : Number(rawValue)
  if (!Number.isFinite(userCount)) return null

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
      <p className="text-sm font-medium text-gray-900 mb-2">
        {formatDateLabel(String(label))}
      </p>
      <div className="space-y-1">
        <p className="text-sm text-rose-600">
          신규 가입: <span className="font-semibold">{formatNumber(userCount)}</span>명
        </p>
      </div>
    </div>
  )
}

export function DailyUserStatsChart({ data }: DailyUserStatsChartProps) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
        <XAxis
          dataKey="date"
          tickFormatter={(value) => {
            const d = new Date(value)
            return `${d.getMonth() + 1}/${d.getDate()}`
          }}
          tick={{ fontSize: 11, fill: '#64748B' }}
          axisLine={{ stroke: '#E2E8F0' }}
          tickLine={false}
          interval="preserveStartEnd"
        />
        <YAxis
          tick={{ fontSize: 11, fill: '#64748B' }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => formatNumber(value)}
          width={45}
          allowDecimals={false}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: '#F1F5F9' }} />
        <Bar
          dataKey="newUsers"
          fill="#F43F5E"
          radius={[4, 4, 0, 0]}
          maxBarSize={32}
        />
      </BarChart>
    </ResponsiveContainer>
  )
}
